import React from 'react';
import './Legal.css';

export const Impressum = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Impressum</h1>
        <p className="legal-subtitle">Angaben gemäß § 5 TMG</p>

        <section className="legal-section">
          <h2>Anbieter</h2>
          <p>
            Niels Höfner<br />
            SocialAgency@nielshoefner.com<br />
            56412 Nentershausen<br />
            Deutschland
          </p>
        </section>

        <section className="legal-section">
          <h2>Kontakt</h2>
          <p>
            <strong>Telefon / WhatsApp:</strong> +49 160 4905213<br />
            <strong>E-Mail:</strong> hoefner.digitalmarketing@gmail.com<br />
            <strong>Instagram:</strong> @hoefner.agency
          </p>
        </section>

        <section className="legal-section">
          <h2>Umsatzsteuer-ID</h2>
          <p>
            Kleinunternehmer gemäß § 19 UStG.<br />
            Es wird daher keine Umsatzsteuer ausgewiesen.
          </p>
        </section>

        <section className="legal-section">
          <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p>
            Niels Höfner<br />
            56412 Nentershausen
          </p>
        </section>

        <section className="legal-section">
          <h2>EU-Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr/
            </a>
            <br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </section>

        <section className="legal-section">
          <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <section className="legal-section">
          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
            Tätigkeit hinweisen.
          </p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
            allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
            erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
            Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </section>

        <section className="legal-section">
          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
            der Seiten verantwortlich.
          </p>
        </section>

        <section className="legal-section">
          <h2>Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
            der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
            Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </section>
      </div>
    </div>
  );
};

export const Datenschutz = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Datenschutzerklärung</h1>
        <p className="legal-subtitle">Stand: Januar 2026</p>

        <section className="legal-section">
          <h2>1. Datenschutz auf einen Blick</h2>
          <h3>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
            personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
            Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>

          <h3>Datenerfassung auf dieser Website</h3>
          <p>
            <strong>Verantwortlicher:</strong> Niels Höfner (Kontaktdaten siehe Impressum)
          </p>
          <p>
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei 
            kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben oder 
            bei einer Terminbuchung.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Hosting</h2>
          <p>
            Diese Website wird bei einem externen Dienstleister gehostet. Die personenbezogenen 
            Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters 
            gespeichert. Hierbei kann es sich vor allem um IP-Adressen, Kontaktanfragen, 
            Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe 
            und sonstige Daten handeln.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
          <h3>Datenschutz</h3>
          <p>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
            Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der 
            gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>

          <h3>Hinweis zur verantwortlichen Stelle</h3>
          <p>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
            Niels Höfner<br />
            56412 Nentershausen<br />
            Telefon: +49 160 4905213<br />
            E-Mail: hoefner.digitalmarketing@gmail.com
          </p>

          <h3>Speicherdauer</h3>
          <p>
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt 
            wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die 
            Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschungsersuchen geltend machen 
            oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Datenerfassung auf dieser Website</h2>
          <h3>Kontaktformular</h3>
          <p>
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus 
            dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks 
            Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. 
            Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>

          <h3>Terminbuchung</h3>
          <p>
            Bei der Buchung eines Termins werden Ihre eingegebenen Daten (Name, E-Mail, Telefon, 
            Datum, Uhrzeit, Anliegen) zum Zwecke der Terminkoordination gespeichert. Die 
            Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines 
            Vertragsverhältnisses).
          </p>

          <h3>Anfrage per E-Mail, Telefon oder WhatsApp</h3>
          <p>
            Wenn Sie uns per E-Mail, Telefon oder WhatsApp kontaktieren, wird Ihre Anfrage 
            inklusive aller daraus hervorgehenden personenbezogenen Daten zum Zwecke der 
            Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Ihre Rechte</h2>
          <p>
            Sie haben jederzeit das Recht:
          </p>
          <ul>
            <li>Auskunft über Ihre bei uns gespeicherten Daten zu erhalten (Art. 15 DSGVO)</li>
            <li>Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
            <li>Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
            <li>Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
            <li>Widerspruch gegen die Verarbeitung einzulegen (Art. 21 DSGVO)</li>
            <li>Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)</li>
            <li>Sich bei einer Aufsichtsbehörde zu beschweren</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. SSL- bzw. TLS-Verschlüsselung</h2>
          <p>
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher 
            Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen 
            Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt 
            und an dem Schloss-Symbol in Ihrer Browserzeile.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Cookies</h2>
          <p>
            Unsere Website verwendet derzeit ausschließlich technisch notwendige Cookies, die 
            für den Betrieb der Website erforderlich sind. Diese Cookies werden auf Grundlage 
            von Art. 6 Abs. 1 lit. f DSGVO gespeichert (berechtigtes Interesse an einer 
            technisch fehlerfreien und optimierten Bereitstellung).
          </p>
        </section>
      </div>
    </div>
  );
};

export const AGB = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Allgemeine Geschäftsbedingungen</h1>
        <p className="legal-subtitle">Stand: Januar 2026</p>

        <section className="legal-section">
          <h2>§ 1 Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge 
            zwischen Niels Höfner (nachfolgend "Auftragnehmer") und seinen Kunden (nachfolgend 
            "Auftraggeber") über die Erbringung von Dienstleistungen im Bereich Social Media 
            Marketing, Content Creation, Beratung und damit zusammenhängenden Leistungen.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 2 Vertragsschluss</h2>
          <p>
            Ein Vertrag kommt durch Annahme des Angebots des Auftragnehmers durch den Auftraggeber 
            zustande. Die Annahme kann schriftlich, per E-Mail, WhatsApp oder durch Beauftragung 
            erfolgen.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 3 Leistungsumfang</h2>
          <p>
            Der genaue Leistungsumfang ergibt sich aus dem jeweiligen Angebot oder der gewählten 
            Paketbeschreibung. Die im Angebot angegebenen Leistungen sind verbindlich. 
            Zusatzleistungen werden gesondert vereinbart und vergütet.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 4 Preise und Zahlungsbedingungen</h2>
          <p>
            Es gelten die zum Zeitpunkt der Beauftragung gültigen Preise. Alle Preise verstehen sich 
            zuzüglich der gesetzlichen Mehrwertsteuer, sofern nicht anders angegeben.
          </p>
          <p>
            Die Setup-Gebühr ist mit Vertragsschluss fällig. Die monatlichen Pakete werden 
            jeweils zum Beginn des Leistungsmonats berechnet und sind innerhalb von 14 Tagen 
            ohne Abzug zu zahlen.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 5 Laufzeit und Kündigung</h2>
          <p>
            Verträge über monatliche Leistungen werden auf unbestimmte Zeit geschlossen und können 
            von beiden Seiten mit einer Frist von 4 Wochen zum Monatsende gekündigt werden. 
            Empfohlene Mindestlaufzeit für nachhaltige Ergebnisse: 3 Monate.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 6 Mitwirkungspflichten</h2>
          <p>
            Der Auftraggeber stellt dem Auftragnehmer alle für die Leistungserbringung erforderlichen 
            Informationen, Zugangsdaten und Materialien rechtzeitig zur Verfügung. Verzögerungen, 
            die aus der mangelnden Mitwirkung resultieren, gehen nicht zu Lasten des Auftragnehmers.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 7 Urheberrecht und Nutzungsrechte</h2>
          <p>
            Alle vom Auftragnehmer erstellten Inhalte (Texte, Grafiken, Videos etc.) sind 
            urheberrechtlich geschützt. Mit vollständiger Zahlung der vereinbarten Vergütung 
            erhält der Auftraggeber das einfache, nicht ausschließliche Nutzungsrecht an den 
            erstellten Inhalten.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 8 Haftung</h2>
          <p>
            Der Auftragnehmer haftet uneingeschränkt für Schäden aus Verletzung des Lebens, des 
            Körpers oder der Gesundheit sowie für Schäden aus Vorsatz und grober Fahrlässigkeit.
          </p>
          <p>
            Eine Erfolgsgarantie für Marketing-Maßnahmen (z.B. Reichweite, Follower-Anzahl, 
            Conversions) wird nicht übernommen, da diese von zahlreichen externen Faktoren abhängen.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 9 Schlussbestimmungen</h2>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser 
            AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
          <p>
            Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Auftragnehmers.
          </p>
        </section>
      </div>
    </div>
  );
};
